import React from 'react';
import Home from './pages/index';
import Terms from './pages/terms';
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import store from "@/app/store";

import './App.scss';
import Artists from "@/pages/artists";
import ArtistDetails from './pages/artists/details';
import PostDetails from './pages/posts/details';
import GeneralPosts from './pages/posts';
import Studios from "@/pages/studios";
import Contact from "@/pages/contact";
import Error404 from "@/pages/errors/error-404";
import Login from "@/pages/auth/login";
import Logout from "@/pages/auth/logout";
import Register from "@/pages/auth/register";
import ResetPass from "@/pages/auth/resetpass";
import About from "@/pages/about";
import StudioDetails from "@/pages/studios/details";
import FAQ from "@/pages/faq";
import ScrollOnNavigation from "@/components/global/scroll-on-navigation";

function App() {
    return (
        <Provider store={store}>
            <BrowserRouter>
                <ScrollOnNavigation />
                <Routes>
                    <Route path="/" element={<Home />} />

                    <Route path="/login" element={<Login />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/password/reset" element={<ResetPass />} />
                    
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/texts" element={<GeneralPosts post_type={"text"} />} />
                    <Route path="/maquettes" element={<GeneralPosts post_type={"maquette"} />} />
                    <Route path="/beats" element={<GeneralPosts post_type={"beat"} />} />
                    <Route path="/posts" element={<GeneralPosts post_type={"posts"} />} />
                    <Route path="/posts/:slug" element={<GeneralPosts post_type={"posts"} />} />
                    <Route path="/studios" element={<Studios />} />
                    <Route path="/studio/:slug" element={<StudioDetails />} />
                    <Route path="/artists" element={<Artists />} />
                    <Route path="/artist/:id" element={<ArtistDetails />} />
                    <Route path="/post/:slug" element={<PostDetails />} />
                    <Route path="*" element={<Error404 />} />
                </Routes>
            </BrowserRouter>
        </Provider>
    );
}

export default App;
